import MarketingLayout from "@/components/layout/MarketingLayout";
import { Card } from "@/components/ui/card";
import { Users, Target, Sparkles, ShieldCheck } from "lucide-react";

export default function About() {
  return (
    <MarketingLayout>
      <section className="page-shell px-6 py-20">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">About Finzpe</div>
          <h1 className="font-display text-5xl lg:text-6xl mt-4 leading-tight">Money that keeps up with modern life.</h1>
          <p className="text-lg text-muted-foreground mt-6">Finzpe was founded to make salaried professionals feel in control of their financial choices — with lending products that are transparent, thoughtfully engineered, and quietly powerful.</p>
        </div>
      </section>

      <section className="page-shell px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <Card className="md:col-span-8 rounded-3xl overflow-hidden relative min-h-[320px]">
            <img alt="modern glass building" src="https://images.unsplash.com/photo-1690944851207-3f288c8fcd0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzcyUyMGJ1aWxkaW5nJTIwY2xlYW58ZW58MHx8fHwxNzg1MTIyNzcxfDA&ixlib=rb-4.1.0&q=85" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="relative z-10 h-full p-8 flex flex-col justify-end text-white">
              <div className="font-display text-3xl max-w-md">Built on the belief that fintech should be calm, honest, and premium.</div>
            </div>
          </Card>
          <Card className="md:col-span-4 rounded-3xl p-8">
            <div className="text-xs uppercase tracking-widest text-primary font-semibold">Our mission</div>
            <p className="mt-3 text-sm">Make lending decisions faster, fairer, and easier to understand — so people can focus on the life they're financing.</p>
            <div className="mt-6 text-xs uppercase tracking-widest text-primary font-semibold">Our promise</div>
            <p className="mt-3 text-sm">Transparent pricing, no dark patterns, no upselling. We tell you what you're paying — and why.</p>
          </Card>
        </div>
      </section>

      <section className="page-shell px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {[
            { icon: Users, k: "200K+", v: "Customers served" },
            { icon: ShieldCheck, k: "99.98%", v: "Uptime SLA" },
            { icon: Target, k: "4.8★", v: "Avg. user rating" },
            { icon: Sparkles, k: "2022", v: "Founded" },
          ].map(({ icon: Icon, k, v }) => (
            <Card key={k} className="p-6 card-hover">
              <Icon className="h-6 w-6 text-primary" />
              <div className="font-display text-3xl mt-3">{k}</div>
              <div className="text-sm text-muted-foreground">{v}</div>
            </Card>
          ))}
        </div>
      </section>

      <section className="page-shell px-6 py-20">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Values</div>
          <h2 className="font-display text-4xl mt-3">Principles we won't compromise on.</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
          {[
            { t: "Radical transparency", b: "You know the interest, fees, and total cost before you sign." },
            { t: "Human review", b: "Underwriting isn't just algorithms — humans review edge cases." },
            { t: "Data dignity", b: "Your data is encrypted, minimised, and never sold." },
          ].map((v) => (
            <Card key={v.t} className="p-6 card-hover">
              <div className="font-display text-xl">{v.t}</div>
              <div className="text-sm text-muted-foreground mt-2">{v.b}</div>
            </Card>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
